/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber28Small = createReactComponent("number-28-small", "IconNumber28Small", [
  [
    "path",
    {
      d: "M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3",
      key: "svg-1"
    }
  ]
]);

export { IconNumber28Small as default };
//# sourceMappingURL=IconNumber28Small.js.map
